import { borderDecomposeMap } from './decomposer';
import { borderComposeMap } from './composer';

export const border = {
  decomposeMap: borderDecomposeMap,
  composeMap: borderComposeMap,
};
